var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"team-banner",style:({ backgroundImage: 'url(' + _vm.photo + ')' }),on:{"click":function (){_vm.goToPlace(_vm.site)}}})}
var staticRenderFns = []

export { render, staticRenderFns }